type SelectedYearProps = {
  initialPosition: number;
  finalPosition: number;
  ranking: number;
  currentYearSpendingPPP: number;
};

export class TableRegion {
  public code: string;
  public name: string;
  public people: number;
  public spending_ppp: number;
  public current_year_spending_ppp?: number;
  public spending_share: number;
  public growthUntilSelected: number;
  public growthToEndYear: number;
  public sortedbySelectedYear?: number;
  public selectedYear?: SelectedYearProps;
  public color?: string;
  public continent?: string;
}
